import useEventCallback from '@unifyapps/hooks/useEventCallback';
import { useYellowAI } from '../../../../../auth/hooks/yellowAI/useYellowAI';
import type { OnActionType } from '../../../../context/ActionsProvider/context';
import { useGetNoCodeComputedData } from '../../../computeContext/useGetNoCodeComputedData';
import { SHOULD_NOT_PROPAGATE_UP } from '../../const';
import { YellowAIControlAction } from './schema/controlYellowAI';

function useControlYellowAI() {
  const { openChatbot, closeChatbot } = useYellowAI();
  const { getNoCodeComputedData } = useGetNoCodeComputedData();

  const onControlYellowAI: OnActionType = useEventCallback((args) => {
    const { action, actionContext } = args;
    const operation = action.payload?.operation;

    switch (operation) {
      case YellowAIControlAction.Open: {
        const payload = (action.payload ?? {}) as Record<string, unknown>;
        const computed = getNoCodeComputedData<{ userToken?: string }>(
          payload,
          (actionContext ?? {}) as Record<string, unknown>,
        );

        const secureToken =
          typeof computed.userToken === 'string' && computed.userToken
            ? computed.userToken
            : undefined;
        openChatbot(secureToken);
        return Promise.resolve(SHOULD_NOT_PROPAGATE_UP);
      }
      case YellowAIControlAction.Close:
        closeChatbot();
        return Promise.resolve(SHOULD_NOT_PROPAGATE_UP);
      default:
        return Promise.resolve(SHOULD_NOT_PROPAGATE_UP);
    }
  });

  return { onControlYellowAI };
}

export default useControlYellowAI;
